<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 13 13`"
    :width="getWidth"
  >
    <path d="M12.6865798,11.2752059 L10.0120483,8.60078361 C10.6565861,7.67035504 10.9790189,6.63311345 10.9790189,5.48960504 C10.9790189,4.7462563 10.834708,4.03532563 10.5460861,3.35697689 C10.2576555,2.67851891 9.86773739,2.09373739 9.3764958,1.6024958 C8.8852542,1.1112542 8.30055462,0.721336134 7.62223319,0.432878151 C6.94369328,0.144338235 6.23281723,8.19327731e-05 5.48946849,8.19327731e-05 C4.74617437,8.19327731e-05 4.0352437,0.144338235 3.35689496,0.432878151 C2.67843697,0.721336134 2.09365546,1.1112542 1.60241387,1.6024958 C1.11111765,2.09373739 0.721254202,2.67862815 0.432768908,3.35697689 C0.144256303,4.03540756 0,4.7462563 0,5.48960504 C0,6.23289916 0.144256303,6.94358403 0.432768908,7.62212395 C0.721226891,8.30047269 1.11111765,8.88517227 1.60241387,9.37641387 C2.09365546,9.86781933 2.67854622,10.2575735 3.35689496,10.5461954 C4.03532563,10.8346807 4.74617437,10.9789097 5.48946849,10.9789097 C6.63322269,10.9789097 7.67030042,10.6564496 8.60078361,10.0119664 L11.2753151,12.6786324 C11.4624496,12.8761176 11.6960672,12.9749286 11.9770147,12.9749286 C12.2473109,12.9749286 12.4813655,12.876145 12.6787416,12.6786324 C12.8761996,12.4811744 12.9750106,12.247229 12.9750106,11.9769328 C12.9750106,11.701584 12.8789307,11.4675567 12.6865798,11.2752059 Z M7.95739286,7.9572563 C7.27382773,8.64093067 6.45125,8.9827542 5.48946849,8.9827542 C4.52785084,8.9827542 3.70527311,8.64084874 3.02165336,7.9572563 C2.33803361,7.27369118 1.99623739,6.45122269 1.99623739,5.48944118 C1.99623739,4.52782353 2.33811555,3.70510924 3.02165336,3.02162605 C3.70513655,2.33797899 4.52785084,1.99621008 5.48946849,1.99621008 C6.45114076,1.99621008 7.27371849,2.33811555 7.95739286,3.02162605 C8.64106723,3.70510924 8.98286345,4.52782353 8.98286345,5.48944118 C8.98286345,6.45122269 8.64095798,7.27369118 7.95739286,7.9572563 Z" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-magnifying-glass'

  export default {
    name: 'SvgIconMagnifyingGlass',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '13',
        type: String
      },
      width: {
        default: '13',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconMagnifyingGlass.vue